import React, { FC } from 'react'
import { SectionHead, SectionHeadProps } from '@mode/components'

export const HomeSectionHead: FC<SectionHeadProps> = (props) => {
  return (
    <SectionHead
      mode="dark"
      {...props}
      body={props._rawBody}
    />
  )
}